<div
  [class]="colorModifier()"
  [class.chart--hidden]="hidden()"
>
  @switch (type()) {
    @case ("bar") {
      <procure-bar-chart
        [horizontal]="horizontal()"
        [dataset]="dataset()"
        [suffix]="suffix()"
        [multiColor]="multiColor()"
      />
    }
    @case ("doughnut") {
      <procure-doughnut-chart [dataset]="dataset()" />
    }
  }
</div>
